import { render, staticRenderFns } from "./view-more-button.vue?vue&type=template&id=110ec920&scoped=true"
import script from "./view-more-button.vue?vue&type=script&lang=js"
export * from "./view-more-button.vue?vue&type=script&lang=js"
import style0 from "./view-more-button.vue?vue&type=style&index=0&id=110ec920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110ec920",
  null
  
)

export default component.exports